// extracted by mini-css-extract-plugin
module.exports = {"container":"BackedAndSupportSection_container__hCINe","section":"BackedAndSupportSection_section__y6AqC"};